module.exports = __webpack_public_path__ + "assets/images/d3ff86267a59cdabff839f9826f223df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/tigerspike-logo.jpg
// module id = 831
// module chunks = 0